import { greaterThan } from '@app/utils/filter/terms/greater-than';
import { greaterThanOrEquals } from '@app/utils/filter/terms/greater-than-or-equals';
import { isIn } from '@app/utils/filter/terms/is-in';
import { keyMatch } from '@app/utils/filter/terms/key-match';
import { lessThan } from '@app/utils/filter/terms/less-than';
import { lessThanOrEquals } from '@app/utils/filter/terms/less-than-or-equals';
import { MapLike } from '@app/utils/filter/terms/map-like';
import { Term } from '@app/utils/filter/terms/term';

export function matchesTerm(term: Term, o: MapLike<string, any[]>): boolean {
  let result: boolean = false;

  if (o.has(term.key)) {
    const value: any[] = o.get(term.key);

    if (term.operator === 'gt') {
      result = greaterThan(value[0], term.arguments[0]);
    } else if (term.operator === 'lt') {
      result = lessThan(value[0], term.arguments[0]);
    } else if (term.operator === 'match') {
      const lowerCasedArguments = term.arguments[0].toLowerCase();
      const lowerCasedValue = value[0].toString().toLowerCase();

      result = keyMatch(lowerCasedValue, lowerCasedArguments);
    } else if (term.operator === 'in') {
      const lowerCasedPossibilities = term.arguments.map((_) => _.toLowerCase());
      const lowerCasedValues = value.map((_) => _.toString().toLowerCase());

      result = isIn(lowerCasedValues, lowerCasedPossibilities);
    } else if (term.operator === 'gte') {
      result = greaterThanOrEquals(value[0], term.arguments[0]);
    } else if (term.operator === 'lte') {
      result = lessThanOrEquals(value[0], term.arguments[0]);
    }
  }

  return result;
}
